module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "boxes"
  }, [_c('el-collapse', {
    staticClass: "formset__list"
  }, _vm._l((_vm.form.boxes), function(box, i) {
    return _c('div', {
      staticClass: "formset__item"
    }, [_c('el-collapse-item', {
      attrs: {
        "name": i
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('formset-header', {
      attrs: {
        "label": ("" + (box.title_pl || 'Nowy box')),
        "errors": _vm.checkForErrors(_vm.errors.boxes, [i]),
        "items": _vm.form.boxes,
        "index": i
      },
      on: {
        "update:items": function($event) {
          return _vm.$set(_vm.form, "boxes", $event)
        }
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Tytuł",
        "error": _vm.errors.boxes && _vm.errors.boxes[i] && _vm.errors.boxes[i]['title']
      }
    }, [_c('el-input', {
      model: {
        value: (box[_vm.addLanguageSuffix('title')]),
        callback: function($$v) {
          _vm.$set(box, _vm.addLanguageSuffix('title'), $$v)
        },
        expression: "box[addLanguageSuffix('title')]"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Opis",
        "error": _vm.errors.boxes && _vm.errors.boxes[i] && _vm.errors.boxes[i]['description']
      }
    }, [_c('wyswig-input', {
      attrs: {
        "simple": ""
      },
      model: {
        value: (box[_vm.addLanguageSuffix('description')]),
        callback: function($$v) {
          _vm.$set(box, _vm.addLanguageSuffix('description'), $$v)
        },
        expression: "box[addLanguageSuffix('description')]"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": ""
      }
    }, [_c('el-tooltip', {
      attrs: {
        "placement": "top",
        "effect": "light"
      }
    }, [_c('div', {
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_c('img', {
      attrs: {
        "src": "/static/help/boxes.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "info",
        "size": "mini"
      }
    }, [_c('i', {
      staticClass: "fa fa-question-circle"
    }), _vm._v(" Pomocnicze informacje dotyczące grafik\n                            ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Grafika (motyw)",
        "error": _vm.errors.boxes && _vm.errors.boxes[i] && _vm.errors.boxes[i]['image']
      }
    }, [_c('image-input-component', {
      model: {
        value: (box.image),
        callback: function($$v) {
          _vm.$set(box, "image", $$v)
        },
        expression: "box.image"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Zdjęcie",
        "error": _vm.errors.boxes && _vm.errors.boxes[i] && _vm.errors.boxes[i]['photo']
      }
    }, [_c('image-input-component', {
      model: {
        value: (box.photo),
        callback: function($$v) {
          _vm.$set(box, "photo", $$v)
        },
        expression: "box.photo"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Kolor tła",
        "error": _vm.errors.boxes && _vm.errors.boxes[i] && _vm.errors.boxes[i]['bg_color']
      }
    }, [_c('el-color-picker', {
      model: {
        value: (box.bg_color),
        callback: function($$v) {
          _vm.$set(box, "bg_color", $$v)
        },
        expression: "box.bg_color"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Kolor tekstu",
        "error": _vm.errors.boxes && _vm.errors.boxes[i] && _vm.errors.boxes[i]['text_color']
      }
    }, [_c('el-color-picker', {
      model: {
        value: (box.text_color),
        callback: function($$v) {
          _vm.$set(box, "text_color", $$v)
        },
        expression: "box.text_color"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Przycisk"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "Nazwa",
        "error": _vm.errors.boxes && _vm.errors.boxes[i] && _vm.errors.boxes[i]['button_title']
      }
    }, [_c('el-input', {
      model: {
        value: (box[_vm.addLanguageSuffix('button_title')]),
        callback: function($$v) {
          _vm.$set(box, _vm.addLanguageSuffix('button_title'), $$v)
        },
        expression: "box[addLanguageSuffix('button_title')]"
      }
    })], 1), _vm._v(" "), _c('link-component', {
      key: box.key || box.id,
      attrs: {
        "errors": _vm.errors.boxes && _vm.errors.boxes[i] && _vm.errors.boxes[i]['button_link']
      },
      model: {
        value: (box.button_link),
        callback: function($$v) {
          _vm.$set(box, "button_link", $$v)
        },
        expression: "box.button_link"
      }
    })], 1)], 2)], 1)
  }), 0), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.addSection
    }
  }, [_vm._v("+ box")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-555cdc53"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/forms/BoxesWidget.vue
// module id = 756
// module chunks = 0